const SEND_PARENTAL_CONOSENT = 'dofe-bo/parental-consent/SEND_PARENTAL_CONOSENT'
const SEND_PARENTAL_CONOSENT_SUCCESS =
  'dofe-bo/parental-consent/SEND_PARENTAL_CONOSENT_SUCCESS'
const SEND_PARENTAL_CONOSENT_FAIL =
  'dofe-bo/parental-consent/SEND_PARENTAL_CONOSENT_FAIL'

const initialState = {
  loaded: false,
  data: {}
}

export default function parentalConsent(state = initialState, action = {}) {
  switch (action.type) {
    case SEND_PARENTAL_CONOSENT:
      return {
        ...state,
        loading: true
      }

    case SEND_PARENTAL_CONOSENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        data: action.result
      }

    case SEND_PARENTAL_CONOSENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function getParticipantRegistration(authCode) {
  return {
    types: [
      SEND_PARENTAL_CONOSENT,
      SEND_PARENTAL_CONOSENT_SUCCESS,
      SEND_PARENTAL_CONOSENT_FAIL
    ],
    promise: client =>
      client.get(
        `api/participant-registrations/using-authorization-code?authorizationCode=${authCode}&with=PARTICIPANT_REGISTRATION_FOR_PARENT_GUARDIAN,PARENTAL_CONSENT`,
        {
          unauthorizedAction: false,
          removeToken: true
        }
      )
  }
}

export function sendParentalConsent(authCode, data) {
  return {
    types: [
      SEND_PARENTAL_CONOSENT,
      SEND_PARENTAL_CONOSENT_SUCCESS,
      SEND_PARENTAL_CONOSENT_FAIL
    ],
    promise: client =>
      client.post(
        `api/participant-registrations/parental-consents?authorizationCode=${authCode}`,
        {
          data,
          unauthorizedAction: false
        }
      )
  }
}
